module.exports = __webpack_public_path__ + "static/4-tips-conten4-751923ac82815e6223bd6c8014576231.png";